import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import SupplementForm from "./SupplementForm";

const AddNewSupplement = () => {
  const [form] = Form.useForm();
  const curdProps = useSelector((state) => state.CurdR);
  const { Add_Supplement_Modal, Loader } = curdProps;

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Supplement"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addSupplement"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_Supplement_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_Supplement_Modal ? Add_Supplement_Modal : false}
      width={500}
      recordName="supplementList"
      form={form}
    >
      <SupplementForm />
    </FormModal>
  );
};

export default AddNewSupplement;
